<template>
  <van-switch
    :value="value"
    :active-color="activeColor"
    :inactive-color="inactiveColor"
    :active-value="activeValue"
    :inactive-value="inactiveValue"
    :size="size"
    @input="onInput"
  />
</template>

<script>
// switch组件
export default {
  name: 'FtSwitch',
  props: {
    value: {
      default() {
        return false;
      }
    },
    activeValue: {
      default() {
        return 1;
      }
    },
    inactiveValue: {
      default() {
        return 0;
      }
    },
    activeColor: {
      default() {
        return '#07c160';
      }
    },
    inactiveColor: {
      default() {
        return '#eaeaea';
      }
    },
    size: {
      default() {
        return '15px';
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    onInput(val) {
      this.$emit('input', val);
    }
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// ftSwitch.vue